import { Box, Container } from '@mui/material'
import { useCallback, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { RouterPaths } from 'src/routes/RouterPaths'
import { APP_VERSION } from 'src/utils/Constants'
import Text from '../Text'
import DefaultImage from './DefaultImage'
import MoveOutPageImage from './MoveOutPageImage'

export interface IFooter {
  isAuthScreen: boolean
}

const Footer = ({ isAuthScreen }: IFooter) => {
  const location = useLocation()
  const isMoveOutPage = useMemo(() => location.pathname === RouterPaths.User.MoveOut, [location.pathname])

  const [count, setCount] = useState(0)

  const onClick = useCallback(() => {
    setCount((prev) => prev + 1)
    if (count === 10) alert(APP_VERSION)
  }, [count])

  return (
    <Container>
      {isMoveOutPage ? <MoveOutPageImage /> : <DefaultImage isAuthScreen={isAuthScreen} />}

      <Box mb={1}>
        <Text color="white" size={12} align="center" onClick={onClick}>
          Copyright&copy;&nbsp;2015&nbsp;M･E･M.Co.Ltd&nbsp;All&nbsp;Right&nbsp;Reserved.
        </Text>
      </Box>
    </Container>
  )
}

export default Footer
